/* global moment */

(function () {
  'use strict';

  angular.module('wsLrs.controllers').controller('NavCtrl', ['$scope', '$rootScope', '$route', '$location', '$timeout', '$uibModal', 'UserRoles', '$window', 'OrganizationSettings', 'wsConfig', 'User', 'SettingsDropdownLinks', 'DataDropdownLinks', 'DefaultCardGroups', 'Interactions', 'Dashboards', 'Demo', 'ViewDashboardsAs', 'wsEventNames', 'AppPermissions', '$http', 'Api', 'Analytics', 'WorkflowsRegistry', function ($scope, $rootScope, $route, $location, $timeout, $uibModal, UserRoles, $window, OrganizationSettings, wsConfig, User, SettingsLinks, DataDropdownLinks, DefaultCardGroups, Interactions, Dashboards, Demo, ViewDashboardsAs, wsEventNames, AppPermissions, $http, Api, Analytics, WorkflowsRegistry) {
    $scope.hide = false;
    $scope.activeView = $location.path().split("/")[1];
    $scope.navbarExpanded = false;
    $scope.isDemoMode = Demo.isDemoMode();
    $scope.startDemo = Demo.startDemo.bind(Demo);
    var removeNavChangeListener = $rootScope.$on("nav:change", function (evt, activeView) {
      // First remove focus which is necessary when back button is use instead of click.
      if (document.activeElement) {
        document.activeElement.blur();
      }
      $scope.activeView = activeView;
      $scope.hide = $scope.activeView === 'hide' || $scope.activeView === 'outsideFacade';
      var routeParams = $route.current.params;
      if (routeParams && routeParams.explorerPreview === 'true') {
        $scope.activeView = "explore";
        $scope.showExplorerTeaser = true;
      } else {
        $scope.showExplorerTeaser = false;
      }
    });
    $scope.exposeEssentials = false;
    $scope.hasYourDashboard = false;
    $scope.settingsLinks = SettingsLinks.get('nav');
    $scope.dataDropdownLinks = DataDropdownLinks.get('nav');
    $scope.dashboardSelected = function (dashboard) {
      Dashboards.changeCurrentDashboard(dashboard);
    };
    $scope.$on(wsEventNames.dashboard.selected, function (evt, selectedDashboard) {
      var dashboard = angular.copy(selectedDashboard);
      if (dashboard.name === 'Your Cards') {
        dashboard.name = 'Your Reports';
      } else if (dashboard.name === 'Watershed Demo') {
        dashboard.link = '#/dashboard/demo';
        dashboard.name = 'Dashboard';
      }
      $scope.currentDashboard = dashboard;
    });
    $scope.$on('$destroy', removeNavChangeListener);
    var user = User.get();

    // Show announcements to admins, including org admins
    if (UserRoles.isOrgManager(user) || UserRoles.isSystemAdmin(user)) {
      $scope.showAnnouncements = true;
      $http.get(Api.url("/alerts/rss/product")).then(function success(result) {
        $scope.announcements = result.data;
        var lastViewed = user.user.lastViewedAnnouncements;
        if ($scope.announcements.length > 0 && (!lastViewed || lastViewed < $scope.announcements[0].date)) {
          $scope.hasUnreadAnnouncements = true;
        }
      });
      $scope.updateLastViewedAnnouncements = function () {
        if ($scope.hasUnreadAnnouncements) {
          $http.get(Api.url("/users/" + user.user.id + "/update-last-viewed-announcements"));
          $scope.hasUnreadAnnouncements = false;
        }
      };
    }
    $scope.organizationName = user.organization && user.organization.name;
    $scope.orgExpireDays = user.organization && user.organization.expireDate && moment.utc(user.organization.expireDate).diff(moment.utc(), 'days');
    $scope.helpLink = "https://watershedlrs.zendesk.com/hc?environment=" + $window.location.hostname;
    $scope.openHelpPage = function openHelpPage() {
      Analytics.helpLinkClicked();
      window.open($scope.helpLink, "_blank");
    };
    $scope.orgSelectionEnabled = true;
    if (!$scope.authenticated) {
      $scope.orgSelectionEnabled = false;
    }
    $scope.navigateToOrgSelection = function navigateToOrgSelection() {
      if ($scope.orgSelectionEnabled) {
        WorkflowsRegistry.clearCache();
        $location.path("/orgs").search("demo", null);
      }
    };
    $scope.$on('$routeChangeSuccess', function () {
      $scope.navbarExpanded = false;
    });
    $scope.organizationImageUrl = user.organization && user.organization.imageUrl;
    function updateLinkVisibility() {
      var user = User.get();
      $scope.isDemoMode = Demo.isDemoMode();
      $scope.exposeOrgPeopleLink = UserRoles.isOrgAdmin(user);
      $scope.exposeOrganizationSelectionLink = !User.belongsToSingleOrg();
      $scope.exposeHelpLink = wsConfig.exposeHelpLink !== false;
      $scope.exposeEssentials = false;
      $scope.exposeDataLink = UserRoles.isOrgAdmin(user) || UserRoles.isOrgManager(user);
      $scope.exposeSignOutLink = true;
      // Only expose settings if there are any menu items available.  When using SSO, even the Your Account
      // is hidden so User role SSO users won't see settings at all.
      $scope.exposeSettingsMenu = $scope.settingsLinks && _.filter($scope.settingsLinks, function (l) {
        return l.condition;
      }).length > 0;
      $scope.exposeAdminLink = UserRoles.isSystemAdmin(user);
      $scope.allowImpersonateUser = UserRoles.isViewDashboardsAsAllowed(user);
      if (ViewDashboardsAs.isActive || Demo.isDemoMode()) {
        $scope.exposeOrganizationSelectionLink = false;
        $scope.exposeHelpLink = false;
        $scope.exposeDataLink = false;
        $scope.exposeSignOutLink = false;
        $scope.exposeSettingsMenu = false;
        $scope.exposeAdminLink = false;
      }
      $scope.helpLink = "https://watershedlrs.zendesk.com/hc?environment=" + $window.location.hostname;
      OrganizationSettings.getForOrganization(user.organization && user.organization.id).then(function (settings) {
        if (settings) {
          if (settings.customHelpUrl) {
            $scope.helpLink = settings.customHelpUrl;
          }
          $scope.essentialsTier = settings.pricingTier === "ESSENTIALS";
          $scope.exposeEssentials = $scope.essentialsTier;
          $scope.hasYourDashboard = OrganizationSettings.hasFeature('yourDashboard');
          Dashboards.getMenu().then(function (menu) {
            $scope.menu = menu;

            // If essentials, don't show other dashboards
            if ($scope.essentialsTier) {
              $scope.menu = [];
            }
            AppPermissions.getForUser({
              value: 'explorer'
            }).then(function (permissions) {
              $scope.exposeExplorerLink = (permissions.length || UserRoles.isExploreAllowed(user)) && !UserRoles.isConsultant(user) && !ViewDashboardsAs.isActive;
            });
          });

          // Essentials related handling
          $scope.showEssentialsWelcome = false;
          if ($scope.essentialsTier) {
            $scope.helpLink = "http://watershedlrs.com/essentials/knowledge-base";
          }
          Interactions.hasAny().then(function (hasInteractions) {
            $scope.hasInteractions = hasInteractions;
            if ($scope.essentialsTier && !hasInteractions && !Demo.isDemoMode()) {
              $scope.showEssentialsWelcome = true;
              $scope.currentDashboard = {
                name: 'Essentials LRS'
              };
            }
          }, function () {
            // If we encounter an error, assume they have no interactions
            if ($scope.essentialsTier && !Demo.isDemoMode()) {
              $scope.showEssentialsWelcome = true;
              $scope.currentDashboard = {
                name: 'Essentials LRS'
              };
            }
          });
        }
      }).catch(function () {
        // NOTE: This catch() block is necessary to remove the annoying "possibly unhandled rejection" error
        // I think this state just means the user didn't have a single
        // organization designated on the user object. This probably isn't
        // an error that needs to "bubble up".
      });
    }
    $scope.$on('$destroy', $rootScope.$on(wsEventNames.nav.update, updateLinkVisibility.bind(this)));
    $scope.$on('$destroy', $rootScope.$on(Demo.demoModeChangeEvent, function () {
      updateLinkVisibility();
    }));
    $scope.$on('$destroy', $rootScope.$on("organization-selected", function () {
      $scope.organizationName = user.organization && user.organization.name;
      $scope.organizationImageUrl = user.organization.imageUrl;
      $scope.settingsLinks = SettingsLinks.get();
      $scope.dataDropdownLinks = DataDropdownLinks.get();
      updateLinkVisibility();
      $scope.hide = false;
    }));
    $scope.explore = function () {
      if ($scope.essentialsTier && !Demo.isDemoMode()) {
        $location.search("explorerPreview", "true");
      } else {
        $rootScope.$broadcast("explore-card");
      }
    };
    $scope.toggleMobileNavbar = function () {
      $scope.navbarExpanded = !$scope.navbarExpanded;
    };
  }]);
})();
